import { render, staticRenderFns } from "./TeamHomeEight.vue?vue&type=template&id=36215fd8&"
import script from "./TeamHomeEight.vue?vue&type=script&lang=js&"
export * from "./TeamHomeEight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports